<template>
  <div class="wrapper">
    <page-header v-if="isAuthedApp" />
    <main class="body" role="main">
      <MembersOnly v-if="error.statusCode === 403" />
      <div v-else>
        <div class="image-container">
          <div class="image" />
        </div>

        <div class="content-container">
          <div class="content">
            <logo class="logo" />

            <h1>{{ error.statusCode }}</h1>
            <p v-if="error.statusCode === 404">{{ $t('ERROR_HTTP_404_LABEL') }}</p>
            <p v-else-if="error.statusCode === 500">{{ $t('ERROR_HTTP_500_GENERAL') }}</p>
            <p v-else>{{ $t('ERROR_HTTP_GENERAL_LABEL') }}</p>
            <sh-button-deprecated
              v-if="isAuthedApp"
              ghost @click="handleClick"
            >
              {{ $t('ERROR_HTTP_BACK_CTA') }}
            </sh-button-deprecated>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import PageHeader from '~/components/page-header'
import MembersOnly from '~/components/members-only'
import Logo from '~/components/logo'

export default {
  layout: 'public',

  props: ['error'],

  // render:errorMiddleware doesn't seem to be working...
  // for now we should just log the error SSR here.
  created () {
    console.log('Page Error', this.error)
    if (this.error && this.$raygun) {
      switch (this.error.statusCode) {
        case 404:
          break
        // Send raygun error
        default:
          this.$raygun.send(this.error)
      }
    }
  },

  components: {
    PageHeader,
    Logo,
    MembersOnly
  },
  methods: {
    handleClick () {
      this.$router.go(-1)
    }
  },
  computed: {
    isAuthedApp () {
      return this.$store.state.initializedApp
    }
  }
}
</script>

<style lang="scss" scoped>

.body {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.content-container {
  width: 70%;
  margin: $d-xx-large auto;
  position: relative;
  background: $color-white;
  min-width: 320px;
  max-width: 100%;
  border-radius: 2px;
  @include shadow(floating);
  background: $color-white;
  @supports (backdrop-filter: blur()) {
    background-color: rgba($color-white, 0.86);
    backdrop-filter: blur(40px);
  }
  @include breakpoint(medium) {
    max-width: $bp-med;
    margin: $d-huge auto;
  }
}

.content {
  padding: $d-med-large $d-x-large;
  text-align: center;
  @include breakpoint(medium) {
    padding: $d-large 20%;
  }
  .logo {
    margin-bottom: $d-x-small;
    margin: 0 auto $space-050;
    width: fit-content;
  }

  h1 {
    @include title-lrg;
    @include deprecated-f-color-dark;
    padding-bottom: $d-small;
    margin-bottom: $d-med-small;
    border-bottom: $line-medium;
  }
  p {
    font-family: $f-family-serif;
    @include font('060');
  }

  a {
    @include label-xx-sml;
    text-decoration: none;
    @include deprecated-f-color-highlight;
  }
}

.image-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  overflow: hidden;
  @include transition-fast;
}

.image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("~assets/images/backgrounds/error-background.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
